import { Grid } from "@mui/material";
import { calculateDateFromTrialPeriodFormat } from "../../../constants";

function IndiPlans({ plans, selectedPlan, setSelectedPlan, promoCodeArea = null, isSale = false }) {
    return (
        <div className="plans-area">
            {plans?.map((plan) => {
                let isYearly = plan.interval_length == 12, monthly;
                let off = 0;

                const nextBill = calculateDateFromTrialPeriodFormat(plan?.trial_length, plan?.trial_unit);

                off = parseFloat(((plan.amount / (plans[1].amount * 12)) * 100 - 100) * -1).toFixed(0);
                monthly = plan?.amount / plan?.interval_length;
                return (
                    <div
                        key={"ip-" + plan.id}
                        className={"clickable plan" + (selectedPlan.id === plan?.id ? " selected g-pink" : "") + (isYearly ? " popPlan" : "")}
                        onClick={() => {
                            setSelectedPlan(plan);
                            localStorage.setItem("current-selected-plan", JSON.stringify(plan));
                        }}
                    >
                        <h6 className={"plan-mp-tag" + (isYearly ? " popular" : "")}>{isSale ? "ON SALE" : "MOST POPULAR"}</h6>
                        <Grid container spacing={0}>
                            <Grid item xs={6}>
                                <div>
                                    <h6>
                                        ${plan?.interval_length == 12 ? monthly?.toFixed(0) : monthly}/month
                                    </h6>
                                    <h4>
                                        {plan.interval_length} MONTH
                                        {isYearly ? "S" : ""}
                                    </h4>
                                </div>
                            </Grid>
                            <Grid item xs={6}>
                                <h6>{isYearly ? `${off}% Off Monthly Plan` : "."}</h6>
                                <h4>${plan?.amount} USD</h4>
                            </Grid>
                        </Grid>
                    </div>
                );
            })}

            {promoCodeArea}
        </div>
    );
}

export default IndiPlans;
